// extracted by mini-css-extract-plugin
export default {"button":"Button_button__hMcHH","xs":"Button_xs__in+8t","s":"Button_s__oY0Yo","m":"Button_m__qnDp3","l":"Button_l__CyAsA"};